import { useTranslator } from '@juit/vue-i18n'
import { watch } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'

import { icons } from '@/assets/icons'
import { env } from '@/init/env'
import { handleError, log } from '@/init/sentry'
import JErrorPage from '@/pages/error.vue'

import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    name: 'Home',
    path: '/',
    component: () => import('@/pages/home.vue'),
  },
  {
    name: 'Users',
    path: '/users',
    component: () => import('@/pages/users.vue'),
  },
  {
    name: 'Report',
    path: '/report',
    component: () => import('@/pages/report.vue'),
  },

  // ===== Catch-all routes ====================================================

  {
    name: 'NotFound',
    path: '/:catchAll(.*)*',
    component: JErrorPage,
    props: () => ({ code: 404, message: 'Not Found' }),
  },
  {
    name: 'InternalError',
    path: '/:catchAll(.*)*',
    component: JErrorPage,
    props: () => ({ code: 500, message: 'Internal Error' }),
  },
]

/* ========================================================================== *
 * Create the router                                                          *
 * ========================================================================== */

/** Our main application router */
export const router = createRouter({
  history: createWebHistory(),
  routes,
})

/* Show a message when _routing_ fails */
router.onError((error) => {
  handleError(error, 'router')
  router.push({ name: 'InternalError', params: {} })
})

/* Expose router on DEV */
if (env.DEV) (globalThis as any).vueRouter = router

/* Log route in dev */
watch(router.currentRoute, (route) => log('%cRoute changed to', 'color: blue', route))

/* ========================================================================== *
 * Main navigation data (shared between header, sidebar, ...)                 *
 * ========================================================================== */

export type NavigationItems = { to: string, label: string, icon: string }[]

export function navigationData(): NavigationItems {
  const { t } = useTranslator()
  return [
    { to: '/users', label: t({ en: 'Users', de: 'Users' }), icon: icons.users },
    { to: '/report', label: t({ en: 'Report', de: 'Bericht' }), icon: icons.report },
  ]
}
